import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Link } from "react-router-dom";
import { db } from "../../config/firebase";
import { collection, getDocs, doc, updateDoc, addDoc } from "firebase/firestore";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { normalizeContactInfo } from "../../firebase/dbService";

const ContactInfo = () => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      organizationName: "",
      street: "",
      city: "",
      telephone: "",
      fax: "",
      email: "",
    },
  });

  const [submitting, setSubmitting] = useState(false);
  const [docId, setDocId] = useState(null);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "contactInfo"));
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setDocId(doc.id);
          const data = normalizeContactInfo(doc.data());
          // Set form values
          setValue("organizationName", data.organizationName);
          setValue("street", data.street);
          setValue("city", data.city);
          setValue("telephone", data.telephone);
          setValue("fax", data.fax);
          setValue("email", data.email);
        }
      } catch (error) {
        console.error("Error fetching contact info:", error);
        toast.error("Error fetching contact info: " + error.message);
      }
    };

    fetchContactInfo();
  }, [setValue]);

  const onSubmit = async (data) => {
    setSubmitting(true);
    const payload = {
      ...data,
      organizationName: data.organizationName,
      practiceName: data.organizationName,
    };
    try {
      if (docId) {
        const docRef = doc(db, "contactInfo", docId);
        await updateDoc(docRef, {
          ...payload,
          updatedAt: new Date()
        });
      } else {
        const docRef = await addDoc(collection(db, "contactInfo"), {
          ...payload,
          createdAt: new Date()
        });
        setDocId(docRef.id);
      }
      toast.success("Contact Information updated successfully!", { autoClose: 2000 });
    } catch (error) {
      toast.error("Failed to update Contact Information: " + error.message, { autoClose: 2000 });
      console.error("Error submitting contact info:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Header />
      <Sidebar id="menu-item12" activeClassName="settings" />
      <div className="page-wrapper">
        <div className="content">
          
          <div className="row">
            <div className="col-12">
              <form onSubmit={handleSubmit(onSubmit)}>
                <h3 className="cs_section_title cs_fs_32 m-0 text-2xl font-semibold mb-3">
                  Contact Information
                </h3>
                <div className="form-group">
                  <label className="text-dark">Organization Name</label>
                  <input
                    className="form-control"
                    {...register("organizationName")}
                  />
                </div>
                <div className="form-group">
                  <label className="text-dark">Street</label>
                  <input
                    className="form-control"
                    {...register("street")}
                  />
                </div>
                <div className="form-group">
                  <label className="text-dark">City</label>
                  <input
                    className="form-control"
                    {...register("city")}
                  />
                </div>
                <div className="form-group">
                  <label className="text-dark">Telephone</label>
                  <input
                    className="form-control"
                    {...register("telephone")}
                  />
                </div>
                <div className="form-group">
                  <label className="text-dark">Fax</label>
                  <input
                    className="form-control"
                    {...register("fax")}
                  />
                </div>
                <div className="form-group">
                  <label className="text-dark">Email</label>
                  <input
                    className="form-control"
                    {...register("email")}
                  />
                </div>
                <div className="form-action-group text-end">
                  <button
                    type="submit"
                    className="btn btn-primary submit-form me-2"
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Save Contact Information"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ContactInfo; 
